export const setThemeColor = (color) => {
    const hexColor = convertToHex(color);
    const lightColor = lightenColor(hexColor, 0);
  
    document.documentElement.style.setProperty("--company-theme", hexColor);
    document.documentElement.style.setProperty("--company-theme-light", lightColor);
  };
  
  const convertToHex = (color) => {
    const ctx = document.createElement("canvas").getContext("2d");
    if (!ctx) return "#002060"; 
    ctx.fillStyle = color;
    return ctx.fillStyle.startsWith("#") ? ctx.fillStyle : "#002060";
  };
  
  const lightenColor = (color, percent) => {
    if (!color.startsWith("#")) return color; 
  
    let num = parseInt(color.replace("#", ""), 16),
        amt = Math.round(2.55 * percent),
        r = (num >> 16) + amt,
        g = ((num >> 8) & 0x00FF) + amt,
        b = (num & 0x0000FF) + amt;
  
    return `#${(0x1000000 +
        (r < 255 ? (r < 1 ? 0 : r) : 255) * 0x10000 +
        (g < 255 ? (g < 1 ? 0 : g) : 255) * 0x100 +
        (b < 255 ? (b < 1 ? 0 : b) : 255))
        .toString(16)
        .slice(1)}`;
  };